import { Formik } from 'formik';
import { useEffect } from 'react';
import { onLink, unloadCallback } from '../../handlers';
import ReactGA from 'react-ga4';
import { Box } from '@chakra-ui/react';
import State from './State';
import SiteHeader from '../../components/SiteHeader';
import SiteFooter from '../../components/SiteFooter';
import SurveyHeader from '../../components/RSSurvey/SurveyHeader';
import RSForm from '../../components/RSSurvey/RSForm';
import { setInitialValues } from '../../components/RSSurvey/utils';
import RSValidation from '../../formControllers/Validation/RSValidation';
import CMPForm from './CMPForm';

//format me
const CMPSurvey = ({ data , appType}) => {
  let props = State(data, appType);
  ReactGA.send({
    hitType: 'pageview',
    page: '/',
    title: 'Home',
  });

  useEffect(() => {


    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);
  const initialValues = setInitialValues(props, data);
  const validationSchema = RSValidation(
    props.sections,
  );
  if (window.preview !== undefined && window.preview !== 0) {
    props.stateProps.setIsAdmin(true);
    props.stateProps.sectionData.sectionName = 'preview';
    props.stateProps.sectionData.resumeIndex = window.preview-1;
    window.preview=0;
  }
  return (
    < >
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {formikProps => {
          props.formikProps = formikProps;
            return (
              <Box  >
                <>
                  <SiteHeader props={props}  />
                  <RSForm props={props} formikProps={formikProps} />
                </>
              </Box>
            );
        }
        }
      </Formik>
    </>
  );
};

export default CMPSurvey;
